export default __webpack_public_path__ + "static/media/DownArrow.43ec7f08.svg";